 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"DataObject~DataObjectModal~DataTable":"DataObject~DataObjectModal~DataTable","DataTable":"DataTable","TreeItemDrillDown":"TreeItemDrillDown","SingleIndicator":"SingleIndicator","ConfirmationModal":"ConfirmationModal","UserSubmenu":"UserSubmenu","GenerateDocumentModal":"GenerateDocumentModal","UserMenu":"UserMenu","DataObject~DataObjectModal":"DataObject~DataObjectModal","DataObject":"DataObject","FavouriteCard":"FavouriteCard","Login":"Login","Navigation":"Navigation","Editor":"Editor","DashboardFeed":"DashboardFeed","DashboardNavigation":"DashboardNavigation","DashboardCharts":"DashboardCharts","DashboardCritical":"DashboardCritical","DashboardIndicators":"DashboardIndicators","FavouriteAddGroup":"FavouriteAddGroup","FavouriteToggler":"FavouriteToggler","TableSeriesLevel":"TableSeriesLevel","TagMultipleInput":"TagMultipleInput","TagSingleInput":"TagSingleInput","FavouriteDeleteGroup":"FavouriteDeleteGroup","FavouriteEditGroup":"FavouriteEditGroup","DataObjectModal":"DataObjectModal","SectionActions":"SectionActions","SectionCodes":"SectionCodes","TextEditor":"TextEditor","VariableModal":"VariableModal","AppChart":"AppChart","ShortCodeTags":"ShortCodeTags"}[chunkId]||chunkId) + "." + {"chunk-16a4b898":"447b8e63","chunk-2d0b8a19":"f85a062a","chunk-2d0ba8fd":"225d23c5","chunk-2d0c1594":"2880788d","chunk-2d0d07e9":"ed0a23d1","chunk-2d0d7476":"6a12c275","chunk-2d0dea85":"9f7c4d68","chunk-2d0e1ba1":"070641c3","chunk-2d0e5379":"741cf6f0","chunk-2d0e6107":"fba31564","chunk-2d0f11cd":"900a6995","chunk-2d207755":"7bcbb113","chunk-2d208096":"ec52e6df","chunk-2d208e57":"0bdc1dd4","chunk-2d20976c":"ec5018be","chunk-2d22996d":"9d3e4c4d","chunk-2d2299e6":"def99361","chunk-2d237ee1":"7d1a6fe4","chunk-36777d71":"6e8798b3","chunk-42cb9839":"1e4ed3aa","chunk-497a2491":"37c8f539","chunk-7a48cf27":"e9882c84","chunk-c19234ee":"3fa0bc38","DataObject~DataObjectModal~DataTable":"04b6e36d","DataTable":"c36ef86a","TreeItemDrillDown":"0354e029","SingleIndicator":"c2a2e13c","ConfirmationModal":"520fcfe1","UserSubmenu":"8976e2c8","GenerateDocumentModal":"b08c1ac8","UserMenu":"836e803c","DataObject~DataObjectModal":"c775bba5","DataObject":"f16d247a","FavouriteCard":"716e5dd9","Login":"49509b9d","Navigation":"6d1c5b81","chunk-2d0c04e6":"f3d70703","Editor":"dbb98f43","DashboardFeed":"6b7f9f75","DashboardNavigation":"1ce6fbd0","DashboardCharts":"e80b11ea","DashboardCritical":"21a0750a","DashboardIndicators":"8d8cc85b","FavouriteAddGroup":"5d43ea42","FavouriteToggler":"6c6e17cb","TableSeriesLevel":"60e85b4c","TagMultipleInput":"521abaac","TagSingleInput":"776f01fd","FavouriteDeleteGroup":"7138309b","FavouriteEditGroup":"60bede7e","DataObjectModal":"b33266ad","SectionActions":"86bd89fc","SectionCodes":"faa741f6","TextEditor":"ba9fcbb5","VariableModal":"3695ecd8","AppChart":"3b439ca0","ShortCodeTags":"8c66bf95"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
